"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    BiddingOrderId: 'u64',
    EraId: 'u32',
    BiddingOrderUnit: {
      bidder_id: 'AccountId',
      token_id: 'AssetId',
      block_num: 'BlockNumber',
      votes: 'Balance',
      annual_roi: 'Permill',
      validator: 'AccountId'
    },
    BiddingOrderUnitOf: 'BiddingOrderUnit'
  }
};
exports.default = _default;